var E;!function(E){E.SENT="sent",E.DELIVERED="DELIVERED",E.SEEN="seen"}(E||(E={}));export{E as ChatMessageStatusEnum};